import React from 'react'

import Pikete from '../../../static/img/Pikete.png'
// import PropTypes from 'prop-types'

const Pricing = () => {
  // const { data } = props

  return (
    <div
      className='hero is-fullheight'
      style={{
        backgroundImage: `url(${Pikete})`,
        backgroundPosition: 'center',
        backgroundSize: '450px 450px',
        backgroundRepeat: 'no-repeat',

      }}>
      {/* {data.map(price => ( */}
      {/* <div key={price.plan}> */}

      {/* <h4 className='has-text-centered has-text-weight-semibold is-family-secondary'>
              {price.plan}
            </h4> */}
      {/* <h2 className='is-size-1 has-text-weight-bold has-text-primary has-text-centered is-family-secondary'>
              ${price.price}
            </h2> */}
      {/* <p className='has-text-weight-semibold is-family-secondary'>{price.description}</p> */}
      {/* <ul>
              {price.items.map(item => (
                <li key={item} className='is-size-5'>
                  {item}
                </li>
              ))}
            </ul> */}
      {/* </section> */}
    </div>
    //   ))}
    // </div>
  )
}

// Pricing.propTypes = {
//   data: PropTypes.arrayOf(
//     PropTypes.shape({
//       plan: PropTypes.string,
//       price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//       description: PropTypes.string,
//       items: PropTypes.array,
//     }),
//   ),
// }

export default Pricing
